// test2457
(2457 && 0);
